import { concat, setCookie } from '../../helpers/common'
import {
  GetAdsPayload,
  GetAdsSuccessPayload,
  GetAdsFailurePayload,
  CreateAdPayload,
  CreateAdSuccessPayload,
  CreateAdFailurePayload,
  ValidateAdPayload,
  ValidateAdSuccessPayload,
  ValidateAdFailurePayload,
  UpdateAdSuccessPayload,
  UpdateAdFailurePayload,
  UpdateAdPayload,
  DeleteAdSuccessPayload,
  DeleteAdFailurePayload,
  GetAdPayload,
  DeleteAdPayload,
  GetAdSuccessPayload,
  GetAdFailurePayload,
  ApproveInternalAdPayload,
  ApproveInternalAdSuccessPayload,
  ApproveInternalAdFailurePayload,
  DisapproveInternalAdPayload,
  DisapproveInternalAdSuccessPayload,
  DisapproveInternalAdFailurePayload,
  SetSelectedAdForCopyPayload,
  CopyAdPayload,
  CopyAdSuccessPayload,
  CopyAdFailurePayload,
  SetAdModifiedDataPayload,
  SetAdCarouselSelectedIndexPayload,
  GetFacebookPostsPayload,
  GetFacebookPostsSuccessPayload,
  GetFacebookPostsFailurePayload,
  SetAdsSortPayload,
  CreateAdsBatchPayload,
  CreateAdsBatchSuccessPayload,
  CreateAdsBatchFailurePayload,
  UpdateAdStatusPayload,
  UpdateAdStatusFailurePayload,
  UpdateAdStatusSuccessPayload
} from '../types/ads'

const MODULE_NAME = 'ADS/'

// PLOP_APPEND_PATTERN_ANCHOR_ACTION
export const GET_ADS = concat(MODULE_NAME, 'GET_ADS')
export const GET_ADS_SUCCESS = concat(MODULE_NAME, 'GET_ADS_SUCCESS')
export const GET_ADS_FAILURE = concat(MODULE_NAME, 'GET_ADS_FAILURE')
export const CLEAR_ADS = concat(MODULE_NAME, 'CLEAR_ADS')

export const CREATE_AD = concat(MODULE_NAME, 'CREATE_AD')
export const CREATE_AD_SUCCESS = concat(MODULE_NAME, 'CREATE_AD_SUCCESS')
export const CREATE_AD_FAILURE = concat(MODULE_NAME, 'CREATE_AD_FAILURE')
export const CLEAR_CREATE_AD = concat(MODULE_NAME, 'CLEAR_CREATE_AD')

export const CREATE_ADS_BATCH = concat(MODULE_NAME, 'CREATE_ADS_BATCH')
export const CREATE_ADS_BATCH_SUCCESS = concat(MODULE_NAME, 'CREATE_ADS_BATCH_SUCCESS')
export const CREATE_ADS_BATCH_FAILURE = concat(MODULE_NAME, 'CREATE_ADS_BATCH_FAILURE')
export const CLEAR_CREATE_ADS_BATCH = concat(MODULE_NAME, 'CLEAR_CREATE_ADS_BATCH')

export const VALIDATE_AD = concat(MODULE_NAME, 'VALIDATE_AD')
export const VALIDATE_AD_SUCCESS = concat(MODULE_NAME, 'VALIDATE_AD_SUCCESS')
export const VALIDATE_AD_FAILURE = concat(MODULE_NAME, 'VALIDATE_AD_FAILURE')
export const CLEAR_VALIDATE_AD = concat(MODULE_NAME, 'CLEAR_VALIDATE_AD')

export const UPDATE_AD = concat(MODULE_NAME, 'UPDATE_AD')
export const UPDATE_AD_SUCCESS = concat(MODULE_NAME, 'UPDATE_AD_SUCCESS')
export const UPDATE_AD_FAILURE = concat(MODULE_NAME, 'UPDATE_AD_FAILURE')
export const CLEAR_UPDATE_AD = concat(MODULE_NAME, 'CLEAR_UPDATE_AD')

export const UPDATE_AD_STATUS = concat(MODULE_NAME, 'UPDATE_AD_STATUS')
export const UPDATE_AD_STATUS_SUCCESS = concat(MODULE_NAME, 'UPDATE_AD_STATUS_SUCCESS')
export const UPDATE_AD_STATUS_FAILURE = concat(MODULE_NAME, 'UPDATE_AD_STATUS_FAILURE')

export const DELETE_AD = concat(MODULE_NAME, 'DELETE_AD')
export const DELETE_AD_SUCCESS = concat(MODULE_NAME, 'DELETE_AD_SUCCESS')
export const DELETE_AD_FAILURE = concat(MODULE_NAME, 'DELETE_AD_FAILURE')
export const CLEAR_DELETE_AD = concat(MODULE_NAME, 'CLEAR_DELETE_AD')

export const GET_AD = concat(MODULE_NAME, 'GET_AD')
export const GET_AD_SUCCESS = concat(MODULE_NAME, 'GET_AD_SUCCESS')
export const GET_AD_FAILURE = concat(MODULE_NAME, 'GET_AD_FAILURE')
export const CLEAR_AD = concat(MODULE_NAME, 'CLEAR_AD')

export const APPROVE_INTERNAL_AD = concat(MODULE_NAME, 'APPROVE_INTERNAL_AD')
export const APPROVE_INTERNAL_AD_SUCCESS = concat(MODULE_NAME, 'APPROVE_INTERNAL_AD_SUCCESS')
export const APPROVE_INTERNAL_AD_FAILURE = concat(MODULE_NAME, 'APPROVE_INTERNAL_AD_FAILURE')
export const CLEAR_APPROVE_INTERNAL_AD = concat(MODULE_NAME, 'CLEAR_APPROVE_INTERNAL_AD')

export const DISAPPROVE_INTERNAL_AD = concat(MODULE_NAME, 'DISAPPROVE_INTERNAL_AD')
export const DISAPPROVE_INTERNAL_AD_SUCCESS = concat(MODULE_NAME, 'DISAPPROVE_INTERNAL_AD_SUCCESS')
export const DISAPPROVE_INTERNAL_AD_FAILURE = concat(MODULE_NAME, 'DISAPPROVE_INTERNAL_AD_FAILURE')
export const CLEAR_DISAPPROVE_INTERNAL_AD = concat(MODULE_NAME, 'CLEAR_DISAPPROVE_INTERNAL_AD')

export const GET_FACEBOOK_POSTS = concat(MODULE_NAME, 'GET_FACEBOOK_POSTS')
export const GET_FACEBOOK_POSTS_SUCCESS = concat(MODULE_NAME, 'GET_FACEBOOK_POSTS_SUCCESS')
export const GET_FACEBOOK_POSTS_FAILURE = concat(MODULE_NAME, 'GET_FACEBOOK_POSTS_FAILURE')
export const CLEAR_FACEBOOK_POSTS = concat(MODULE_NAME, 'CLEAR_FACEBOOK_POSTS')

// COPY AD START
export const SET_SELECTED_AD_FOR_COPY = concat(MODULE_NAME, 'SET_SELECTED_AD_FOR_COPY')
export const CLEAR_SELECTED_AD_FOR_COPY = concat(MODULE_NAME, 'CLEAR_SELECTED_AD_FOR_COPY')

export const COPY_AD = concat(MODULE_NAME, 'COPY_AD')
export const COPY_AD_SUCCESS = concat(MODULE_NAME, 'COPY_AD_SUCCESS')
export const COPY_AD_FAILURE = concat(MODULE_NAME, 'COPY_AD_FAILURE')
export const CLEAR_COPY_AD = concat(MODULE_NAME, 'CLEAR_COPY_AD')
// COPY AD END

// modified data used for AdPreview component to represent unsaved changes from EditForm
export const SET_AD_MODIFIED_DATA = concat(MODULE_NAME, 'SET_AD_MODIFIED_DATA')
export const SET_AD_CAROUSEL_SELECTED_INDEX = concat(MODULE_NAME, 'SET_AD_CAROUSEL_SELECTED_INDEX')
export const TOGGLE_IS_SOUND_MUTED = concat(MODULE_NAME, 'TOGGLE_IS_SOUND_MUTED')
export const CLEAR_AD_PREVIEW = concat(MODULE_NAME, 'CLEAR_AD_PREVIEW')

// sort option inside AdsList component
export const SORT = concat(MODULE_NAME, 'SORT')
export const SET_ADS_SORT = concat(MODULE_NAME, 'SET_ADS_SORT')

export const DELETE_COMBINED_AD = concat(MODULE_NAME, 'DELETE_COMBINED_AD')
// this action is used to manually update ads list, for example when delete line item
export const UPDATE_ADS_LIST = concat(MODULE_NAME, 'UPDATE_ADS_LIST')

// PLOP_APPEND_PATTERN_ANCHOR_ACTION_CREATOR

export function getAds(params: GetAdsPayload['params'], platform: string): GetAdsPayload {
  return { type: GET_ADS, params, platform }
}

export function getAdsSuccess(adsData: any[]): GetAdsSuccessPayload {
  return { type: GET_ADS_SUCCESS, adsData }
}

export function getAdsFailure(error: object): GetAdsFailurePayload {
  return { type: GET_ADS_FAILURE, error }
}

export function clearAds() {
  return { type: CLEAR_ADS }
}

// create ad
export function createAd(adData: object, platform: string): CreateAdPayload {
  return { type: CREATE_AD, adData, platform }
}

export function createAdSuccess(adData: any): CreateAdSuccessPayload {
  return { type: CREATE_AD_SUCCESS, adData }
}

export function createAdFailure(error: object): CreateAdFailurePayload {
  return { type: CREATE_AD_FAILURE, error }
}

export function clearCreateAd() {
  return { type: CLEAR_CREATE_AD }
}

// Create ads batch
export function createAdsBatch(adsData: object, platform: string): CreateAdsBatchPayload {
  return { type: CREATE_ADS_BATCH, adsData, platform }
}

export function createAdsBatchSuccess(adsData: object): CreateAdsBatchSuccessPayload {
  return { type: CREATE_ADS_BATCH_SUCCESS, adsData }
}

export function createAdsBatchFailure(error: object): CreateAdsBatchFailurePayload {
  return { type: CREATE_ADS_BATCH_FAILURE, error }
}

export function clearCreateAdsBatch() {
  return { type: CLEAR_CREATE_ADS_BATCH }
}

// validate ad
export function validateAd(adData: ValidateAdPayload['adData'], platform: string): ValidateAdPayload {
  return { type: VALIDATE_AD, adData, platform }
}

export function validateAdSuccess(adData: any, conversionDomain: string): ValidateAdSuccessPayload {
  return { type: VALIDATE_AD_SUCCESS, adData, conversionDomain }
}

export function validateAdFailure(error: object, conversionDomain: string): ValidateAdFailurePayload {
  return { type: VALIDATE_AD_FAILURE, error, conversionDomain }
}

export function clearValidateAd() {
  return { type: CLEAR_VALIDATE_AD }
}

// update ad
export function updateAd(adData: object, id: string, platform: string, updateOptions: object = {}): UpdateAdPayload {
  return { type: UPDATE_AD, adData, id, platform, updateOptions }
}

export function updateAdSuccess(adData: any): UpdateAdSuccessPayload {
  return { type: UPDATE_AD_SUCCESS, adData }
}

export function updateAdFailure(error: object): UpdateAdFailurePayload {
  return { type: UPDATE_AD_FAILURE, error }
}

export function clearUpdateAd() {
  return { type: CLEAR_UPDATE_AD }
}

// update ad status
export function updateAdStatus(updateData: UpdateAdStatusPayload['updateData']): UpdateAdStatusPayload {
  return { type: UPDATE_AD_STATUS, updateData }
}

export function updateAdStatusSuccess(
  updateData: UpdateAdStatusSuccessPayload['updateData']
): UpdateAdStatusSuccessPayload {
  return { type: UPDATE_AD_STATUS_SUCCESS, updateData }
}

export function updateAdStatusFailure(error: object): UpdateAdStatusFailurePayload {
  return { type: UPDATE_AD_STATUS_FAILURE, error }
}

export function deleteAd(
  { id, ...params }: { id: string; [key: string]: any },
  platform: string,
  deleteOptions: object = {}
): DeleteAdPayload {
  return { type: DELETE_AD, params, id, platform, deleteOptions }
}

export function deleteAdSuccess(id: string): DeleteAdSuccessPayload {
  return { type: DELETE_AD_SUCCESS, id }
}

export function deleteAdFailure(error: object): DeleteAdFailurePayload {
  return { type: DELETE_AD_FAILURE, error }
}

export function clearDeleteAd() {
  return { type: CLEAR_DELETE_AD }
}

export function getAd(params: GetAdPayload['params'], platform: string, pushToList = false): GetAdPayload {
  return { type: GET_AD, params, platform, pushToList }
}

export function getAdSuccess(adData: object, pushToList: boolean): GetAdSuccessPayload {
  return { type: GET_AD_SUCCESS, adData, pushToList }
}

export function getAdFailure(error: object): GetAdFailurePayload {
  return { type: GET_AD_FAILURE, error }
}

export function clearAd() {
  return { type: CLEAR_AD }
}

// Approve internal ad
export function approveInternalAd(id: string): ApproveInternalAdPayload {
  return { type: APPROVE_INTERNAL_AD, id }
}

export function approveInternalAdSuccess(data: object, id: string): ApproveInternalAdSuccessPayload {
  return { type: APPROVE_INTERNAL_AD_SUCCESS, data, id }
}

export function approveInternalAdFailure(error: object, id: string | number): ApproveInternalAdFailurePayload {
  return { type: APPROVE_INTERNAL_AD_FAILURE, error, id }
}

export function clearApproveInternalAd(id: string) {
  return { type: CLEAR_APPROVE_INTERNAL_AD, id }
}

// Disapprove internal ad
export function disapproveInternalAd(id: string, data: object): DisapproveInternalAdPayload {
  return { type: DISAPPROVE_INTERNAL_AD, id, data }
}

export function disapproveInternalAdSuccess(id: string): DisapproveInternalAdSuccessPayload {
  return { type: DISAPPROVE_INTERNAL_AD_SUCCESS, id }
}

export function disapproveInternalAdFailure(error: object, id: string | number): DisapproveInternalAdFailurePayload {
  return { type: DISAPPROVE_INTERNAL_AD_FAILURE, error, id }
}

export function clearDisapproveInternalAd(id: string) {
  return { type: CLEAR_DISAPPROVE_INTERNAL_AD, id }
}

// COPY AD
export function setSelectedAdForCopy(adData: any): SetSelectedAdForCopyPayload {
  return { type: SET_SELECTED_AD_FOR_COPY, adData }
}

export function clearSelectedAdForCopy() {
  return { type: CLEAR_SELECTED_AD_FOR_COPY }
}

export function copyAd(data: CopyAdPayload['data'], adId: string, platform: string): CopyAdPayload {
  return { type: COPY_AD, data, adId, platform }
}

export function copyAdSuccess(copiedAdDetails: object): CopyAdSuccessPayload {
  return { type: COPY_AD_SUCCESS, copiedAdDetails }
}

export function copyAdFailure(error: object): CopyAdFailurePayload {
  return { type: COPY_AD_FAILURE, error }
}

export function clearCopyAd() {
  return { type: CLEAR_COPY_AD }
}

// other actions
export function setAdModifiedData(adModifiedData: object): SetAdModifiedDataPayload {
  return { type: SET_AD_MODIFIED_DATA, adModifiedData }
}

export function setAdCarouselSelectedIndex(adId: string, selectedIndex: number): SetAdCarouselSelectedIndexPayload {
  return { type: SET_AD_CAROUSEL_SELECTED_INDEX, adId, selectedIndex }
}

export function toggleIsSoundMuted() {
  return { type: TOGGLE_IS_SOUND_MUTED }
}

export function clearAdPreview() {
  return { type: CLEAR_AD_PREVIEW }
}

export function setAdsSort(sort: string): SetAdsSortPayload {
  setCookie(SORT, sort, 1)
  return { type: SET_ADS_SORT, sort }
}

// get facebook posts
export function getFacebookPosts(params: GetFacebookPostsPayload['params']): GetFacebookPostsPayload {
  return { type: GET_FACEBOOK_POSTS, params }
}

export function getFacebookPostsSuccess(
  postsData: GetFacebookPostsSuccessPayload['postsData']
): GetFacebookPostsSuccessPayload {
  return { type: GET_FACEBOOK_POSTS_SUCCESS, postsData }
}

export function getFacebookPostsFailure(error: object): GetFacebookPostsFailurePayload {
  return { type: GET_FACEBOOK_POSTS_FAILURE, error }
}

export function clearFacebookPosts() {
  return { type: CLEAR_FACEBOOK_POSTS }
}

export function deleteCombinedAd(adId: string): any {
  return { type: DELETE_COMBINED_AD, adId }
}

export function updateAdsList(ads: []) {
  return { type: UPDATE_ADS_LIST, ads }
}
